<template>
  <BgImageLayout title="Publisher/Vendor import" height="200px">
    <AgGridWrapper
      :title="`Import ${id} - ${importedOnText}`"
      :options="gridOptions"
      :actions="actions"
      :include-search-box="true"
      @download-file="download"
    />
  </BgImageLayout>
</template>

<script>
import gridOptions from './gridOptions'
import * as apiTo from '@/modular-api'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'

export default {
  components: {
    AgGridWrapper
  },

  mixins: [gridOptions],

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    singleImport: null
  }),

  computed: {
    agGridRows() {
      if (!this.singleImport) return null
      return this.singleImport.providers
    },

    importFile() {
      if (!this.singleImport) return null
      return this.singleImport.file
    },

    importedOnText() {
      if (!this.singleImport) return ''
      return this.formatDateTimeForLocale(this.singleImport.created_at)
    }
  },

  created() {
    apiTo.GET_PROVIDERS_IMPORT(this.id).then(({ data }) => (this.singleImport = data.result))
  },

  methods: {
    download() {
      this.$store.dispatch('downloadMedia', this.importFile.id, {
        root: true
      })
    }
  }
}
</script>
